export default __webpack_public_path__ + "static/media/brunch.4b18dcff.svg";